<template>
    <div>
        <modal size="small">
            <div slot="header">Erreur Coûteuse !!!
                <br>
                <div class="note">
                    Et oui t'as plus de 100 kpO en trésor, donc paf, erreur coûteuse. 
                </div>
            </div>
            <div slot="body">
                <div class="row columns">
                    <div class="large-6 columns">
                        <div class="row columns note">
                        Jet d'erreur coûteuse :
                        </div>
                        <div class="row columns">
                        <br>
                            <img class="large-7 large-centered team-icon-big" v-bind:src="getDiceIcon()" alt="">
                        </div>
                        <br>
                    </div>
                    <div class="large-6 columns">
                        <div class="row columns note">
                        Résultat :
                        </div>
                        <div v-if="this.spiralingExpenseResult.lost_treasury !== 0" class="row columns">
                        <br>
                            tu perds {{this.spiralingExpenseResult.lost_treasury}} 000 pO 
                        </div>
                        <div v-if="this.spiralingExpenseResult.lost_treasury === 0" class="row columns">
                            tu perds rien 
                        </div>
                        <div class="row columns">
                            {{getMessage()}}
                        </div>
                        <br>
                    </div>
                </div>
            </div>
            <div slot="footer" class="panel-footer" >
                <div class="row columns">
                <button @click="$emit('closeMessage')" class="">Ok</button>
            </div>
          </div>
      </modal>
    </div>
</template>

<script>
import modal from './modal.vue'

export default {
  name: 'spiralingExpenseModal',
  components: {
    modal
  },
  props: {
    'spiralingExpenseResult': null,
    'spiralling_roll': null,
    'lost_treasury': null
  },
  data () {
    return {
      showModal: false
    }
  },
  methods: {
    getDiceIcon () {
      return '/static/imgs/dices/' + this.spiralingExpenseResult.spiralling_roll + '.png'
    },
    getMessage () {
      if (this.spiralingExpenseResult.lost_treasury <= 30) {
        return 'chattard !'
      }
      if (this.spiralingExpenseResult.lost_treasury <= 60) {
        return 'ça te fait la bite'
      }
      if (this.spiralingExpenseResult.lost_treasury <= 100) {
        return 'Tu la ramèneras moins déjà'
      }
      if (this.spiralingExpenseResult.lost_treasury > 100) {
        return 'Sa mère la pute, ça pique !'
      }
    }

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-mask {
  position:fixed
}
.note {
    font-size: 0.7em;
}
</style>



// WEBPACK FOOTER //
// spiraling-expense-modal.vue?2bd8639f